import type { PatientSyncResult } from '@vagusx/clients';

export interface PatientSyncToast {
  level: 'success' | 'warning';
  message: string;
}

/**
 * The toast for patient detail → Sync EHR. A refresh succeeds once the patient
 * is read, so problems after that must be said out loud: a plain "synced" over
 * an empty Appointments tab is how a sync that stored none of the patient's
 * appointments went unnoticed (athena verification matrix R10).
 *
 * The problem count is not a record count (one failed read can cost many
 * records, an insurance read none), so the message says data may be missing
 * rather than how many records were dropped.
 *
 * The appointment count is deliberately not shown: OfficeAlly's patient refresh
 * stores no appointments by design (its calendar sync owns them), so "0
 * appointments" there would be true and misleading.
 */
export function patientSyncToast(result: PatientSyncResult): PatientSyncToast {
  if (result.errors === 0) return { level: 'success', message: 'Patient synced from EHR' };
  const problems = `${result.errors} problem${result.errors === 1 ? '' : 's'}`;
  return {
    level: 'warning',
    message: `Patient synced from EHR with ${problems}; some of their records may be missing`,
  };
}
